import { writable } from "svelte/store";
export const currentRoute = writable("Home");
export const demoModeAlert = writable(false);
export const productsStore = writable([
    {
        id: 1,
        name: "Wireless Headphones",
        description: "High-quality noise-canceling wireless headphones.",
        price: 199.99,
        image: "https://plus.unsplash.com/premium_photo-1677838847804-4054143fb91a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8aGVhZHBob25lc3xlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 2,
        name: "Smart Watch",
        description: "Fitness tracker with sleep monitoring and heart rate sensor.",
        price: 149.5,
        image: "https://images.unsplash.com/photo-1660844817855-3ecc7ef21f12?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c21hcnR3YXRjaHxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 3,
        name: "Gaming Mouse",
        description: "Ergonomic gaming mouse with programmable buttons and RGB.",
        price: 59.9,
        image: "https://images.unsplash.com/photo-1628832307345-7404b47f1751?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z2FtaW5nJTIwbW91c2V8ZW58MHx8MHx8fDA%3D",
    },
    {
        id: 4,
        name: "Mechanical Keyboard",
        description: "Tenkeyless mechanical keyboard with tactile switches.",
        price: 120.0,
        image: "https://plus.unsplash.com/premium_photo-1725075085043-79932bdbcde6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fE1lY2hhbmljYWwlMjBLZXlib2FyZHxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 5,
        name: "4K Action Camera",
        description: "Waterproof action camera with incredible stabilization.",
        price: 299.99,
        image: "https://images.unsplash.com/photo-1772650713936-c0a588419086?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGFjdGlvbiUyMGNhbWVyYXxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 6,
        name: "Bluetooth Speaker",
        description: "Portable waterproof speaker with deep bass.",
        price: 45.0,
        image: "https://images.unsplash.com/photo-1589256469067-ea99122bbdc4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Ymx1ZXRvb3RoJTIwc3BlYWtlcnxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 7,
        name: "Laptop Backpack",
        description: "Anti-theft laptop backpack with USB charging port.",
        price: 35.8,
        image: "https://images.unsplash.com/photo-1667411424771-cadd97150827?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGFwdG9wJTIwYmFja3BhY2t8ZW58MHx8MHx8fDA%3D",
    },
    {
        id: 8,
        name: "HD Webcam",
        description: "1080p webcam for streaming and video calls.",
        price: 49.99,
        image: "https://images.unsplash.com/photo-1626581795188-8efb9a00eeec?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8aGQlMjB3ZWJjYW18ZW58MHx8MHx8fDA%3D",
    },
    {
        id: 9,
        name: "External SSD 1TB",
        description: "Fast and portable solid-state drive with USB-C.",
        price: 109.99,
        image: "https://plus.unsplash.com/premium_photo-1721133260774-84f57d69cb82?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8c3NkfGVufDB8fDB8fHww",
    },
    {
        id: 10,
        name: "USB-C Hub",
        description: "7-in-1 multi-port adapter for modern laptops.",
        price: 25.5,
        image: "https://plus.unsplash.com/premium_photo-1761043248662-42f371ad31b4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNiJTIwYyUyMGh1YnxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 11,
        name: "Wireless Charger",
        description: "Fast charging pad for Qi-enabled devices.",
        price: 19.99,
        image: "https://images.unsplash.com/photo-1603674554159-b62f6febbce5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8d2lyZWxlc3MlMjBjaGFyZ2V8ZW58MHx8MHx8fDA%3D",
    },
    {
        id: 12,
        name: "Noise-Isolating Earbuds",
        description: "True wireless earbuds with superior sound quality.",
        price: 89.9,
        image: "https://images.unsplash.com/photo-1655560378428-7605bda51749?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGVhcmJ1ZHN8ZW58MHx8MHx8fDA%3D",
    },
    {
        id: 13,
        name: "Power Bank 20000mAh",
        description: "High-capacity portable charger with fast charge support.",
        price: 39.99,
        image: "https://images.unsplash.com/photo-1585995603413-eb35b5f4a50b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cG93ZXJiYW5rfGVufDB8fDB8fHww",
    },
    {
        id: 14,
        name: "Smartphone Tripod",
        description: "Flexible wrap-around tripod for phones and small cameras.",
        price: 15.0,
        image: "https://plus.unsplash.com/premium_photo-1710409625188-d34e3e813f6c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8VHJpcG9kfGVufDB8fDB8fHww",
    },
    {
        id: 15,
        name: 'LED Monitor 27"',
        description: "Ultra-thin IPS monitor with eye-care technology.",
        price: 249.99,
        image: "https://plus.unsplash.com/premium_photo-1680721575881-6fad8bf84f51?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8bGVkJTIwbW9uaXRvcnxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 16,
        name: "Ergonomic Office Chair",
        description: "Mesh high-back chair with lumbar support.",
        price: 189.0,
        image: "https://images.unsplash.com/photo-1505797149-43b0069ec26b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fG9mZmljZSUyMGNoYWlyfGVufDB8fDB8fHww",
    },
    {
        id: 17,
        name: "Desk Lamp",
        description: "Dimmable LED desk lamp with wireless charging base.",
        price: 45.99,
        image: "https://images.unsplash.com/photo-1505797149-43b0069ec26b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fG9mZmljZSUyMGNoYWlyfGVufDB8fDB8fHww",
    },
    {
        id: 18,
        name: "Wireless Gamepad",
        description: "Rechargeable wireless controller for PC and mobile.",
        price: 34.5,
        image: "https://images.unsplash.com/photo-1752833005527-38a858157afd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8V2lyZWxlc3MlMjBHYW1lcGFkfGVufDB8fDB8fHww",
    },
    {
        id: 19,
        name: "Fitness Resistance Bands",
        description: "Set of 5 resistance bands with different tension levels.",
        price: 22.0,
        image: "https://images.unsplash.com/photo-1584827386916-b5351d3ba34b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Rml0bmVzcyUyMFJlc2lzdGFuY2UlMjBCYW5kc3xlbnwwfHwwfHx8MA%3D%3D",
    },
    {
        id: 20,
        name: "Yoga Mat",
        description: "Non-slip eco-friendly exercise mat with carrying strap.",
        price: 28.5,
        image: "https://images.unsplash.com/photo-1591291621060-89264efbeaed?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHlvZ2ElMjBtYXR8ZW58MHx8MHx8fDA%3D",
    },
]);
export const ordersStore = writable(Array.from({ length: 25 }, (_, i) => ({
    id: `ORD-${1000 + i}`,
    customer: `Customer ${i + 1}`,
    date: new Date(Date.now() - Math.random() * 10000000000)
        .toISOString()
        .split("T")[0],
    total: (Math.random() * 500 + 20).toFixed(2),
    status: ["Pending", "Processing", "Shipped", "Delivered"][Math.floor(Math.random() * 4)],
})));
